import React from "react";
import {ListItemText, ListItemTextProps, SxProps, Typography} from "@mui/material";
import * as ST from "./styled";

interface StyledListItemTextProps extends ListItemTextProps {
	text: string
	sx?: SxProps
	sxWrapper?: SxProps
}

const SubMenuItemText: React.FC<StyledListItemTextProps> = ({text, sx, sxWrapper}) => {
	return <ListItemText
		sx={sxWrapper}
		primary={
			<Typography
				sx={{
					...ST.ListItemTextStyles,
					...sx
				}}
			>{text}</Typography>
		}
	/>
}

export default SubMenuItemText